import { PENDING_CONTACT_LINK_INTENT } from 'constants/loanApplication';

import { RESET_STATE } from 'store/global/actions';
import { LOAN_APPLICATION_BORROWER_CONTACT_LINK_ACTION_TYPE } from 'store/loanApplications/actions';

const initialState = {};

const loanApplicationBorrowerPendingContactLinksReducer = (
  state = initialState,
  { type, payload },
) => {
  switch (type) {
    case LOAN_APPLICATION_BORROWER_CONTACT_LINK_ACTION_TYPE.SET_PENDING_BORROWER_CONTACT_LINK: {
      return {
        ...state,
        [payload.borrowerId]: {
          action: PENDING_CONTACT_LINK_INTENT.LINK,
          contact: payload.contact,
        },
      };
    }

    case LOAN_APPLICATION_BORROWER_CONTACT_LINK_ACTION_TYPE.SET_PENDING_BORROWER_CONTACT_UNLINK: {
      return {
        ...state,
        [payload.borrowerId]: {
          action: PENDING_CONTACT_LINK_INTENT.UNLINK,
          contact: payload.contact,
        },
      };
    }

    case LOAN_APPLICATION_BORROWER_CONTACT_LINK_ACTION_TYPE.CLEAR_PENDING_BORROWER_CONTACT_LINK: {
      const { [payload.borrowerId]: _removed, ...rest } = state;

      return rest;
    }

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default loanApplicationBorrowerPendingContactLinksReducer;
